import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Clipboard from 'clipboard';

import {getMessage} from './../../utils/i18n';
import {getIconClass} from './../../utils/icons';

import './tenant.css';

new Clipboard('.foClipboard');

class Tenant extends Component {
    static propTypes = {
        tenant: PropTypes.object.isRequired,
        index: PropTypes.number.isRequired,
        mspManaged: PropTypes.string.isRequired
    };

    render() {
        const {index, mspManaged} = this.props;
        const {id, name, tenantState, tenantType, description, product} = this.props.tenant;
        let url = this.props.tenant.url;

        // modify url for custom domain
        let customDomain = this.props.tenant.customDomain;
        if (url && customDomain) {
            let urlParser = document.createElement('a');
            urlParser.href = url;
            let portPart = '';
            if (urlParser.port) {
                portPart = ':' + urlParser.port;
            }
            url = urlParser.protocol + '//' + customDomain + portPart + urlParser.pathname
        }

        if (url && mspManaged === 'true') {
            if (customDomain) {
                url = url + '?SHARED=TRUE';
            } else {
                url = url + '&SHARED=TRUE';
            }
        }
        return <div className="foSiteContainer">
            <div className={`foSiteLogo_${product || "ITSMA-X"}`}/>
            <div className="foSiteContent">
                <div className="foSiteHeader">
                    <div className="foSiteTitle">
                        {id + ' ' + name}
                    </div>
                    <span className="foSiteState">{getMessage(`tenant.state.${tenantState}`)}</span>
                </div>
                <div className="foSiteSecondLine">
                    <span className="foSiteAttributeGroup">
                        <span className="foSiteAttribute">
                            <span className="foSiteAttributeName">
                                {getMessage("tenant.attribute-name.product")}
                            </span>
                            <span className="foSiteAttributeValue">
                                {getMessage(`tenant.product.${product || "ITSMA-X"}`)}
                            </span>
                        </span>
                        <span className="foSiteAttribute">
                            <span className="foSiteAttributeName">
                                {getMessage("tenant.attribute-name.tenant-type")}
                            </span>
                            <span className="foSiteAttributeValue">
                                {getMessage(`tenant.type.${tenantType}`)}
                            </span>
                        </span>
                        <span className="foSiteAttribute">
                            <span className="foSiteAttributeName">
                                {getMessage("tenant.attribute-name.url")}
                            </span>
                            <span id={`foSiteUrl-${index}`} className="foSiteAttributeValue">
                                {
                                    url || getMessage('tenant.url-not-available')
                                }
                            </span>
                        </span>
                        {
                            url &&
                            <span className={"foSiteCopyUrl foClipboard " + getIconClass("copy")}
                                  title={getMessage('tenant.copy-link')}
                                  data-clipboard-target={`#foSiteUrl-${index}`}/>
                        }
                    </span>
                    {
                        url&&'ACTIVE'===tenantState ?
                            <a className="foSiteLink"
                               href={url}
                               target="_blank"
                               rel="noopener noreferrer"
                            >
                                {getMessage('app.action.enter-tenant')}
                            </a> :
                            <span className="foSiteLink foSiteLinkDisabled" >
                                {getMessage('app.action.enter-tenant')}
                            </span>
                    }
                </div>
                <div className="foSiteDescription">
                    {description}
                </div>
            </div>
        </div>
    }
}

export default Tenant


// WEBPACK FOOTER //
// ./src/app/components/tenant/index.js